import { FC, ReactNode } from 'react';

import NoItemsAvailable from 'modules/_shared/components/EmptyStates/NoItemsAvailable';

type TableBodyProps = {
  hasData: boolean;
  content: ReactNode;
  noDataMessage: string;
  noDataColspan?: number;
};

const TableBody: FC<TableBodyProps> = ({
  hasData,
  content,
  noDataMessage,
  noDataColspan = 9,
}) => (
  <tbody>
    {hasData ? (
      content
    ) : (
      <NoItemsAvailable mainMessage={noDataMessage} colspan={noDataColspan} />
    )}
  </tbody>
);

export default TableBody;
